class articleMember {
  constructor($t) {
    this.$t = $t;
    this.$modalTriggers = document.querySelectorAll('[aria-controls="member-login"]');
    this.$modal = document.querySelector('.article-member-modal');
    this.$modalForm = this.$modal.querySelector('.armm-form form');
    this.$modalFormId = this.$modal.querySelector('[name="article-member-id"]');
    this.$modalFormPassword = this.$modal.querySelector('[name="article-member-password"]');
    this.$modalFormSubmit = this.$modal.querySelector('.armm-form-submit');
    this.$modalClose = this.$modal.querySelector('.armm-close');
    this.$continue = document.querySelector('.article-continue');
    this.cookieSettings = {
      name: 'media-article-column',
      expires: 7,
      path: '/'
    };
    this.login = {
      id: 'media',
      password: 'funaimedia'
    };
    this.isLoggedIn = document.cookie.includes(`${this.cookieSettings.name}=`) ? true : false;

    if (this.isLoggedIn) {
      this._articleDisplay();
    };

    this.$modalTriggers.forEach($trigger => {
      $trigger.addEventListener('click', event => {
        event.preventDefault();
        this._modal($trigger);
        return false;
      });
    });

    this.$modalForm.addEventListener('submit', event => {
      event.preventDefault();
      this._submit();
    });
  };
  _modal = $trigger => {
    let controls = $trigger.getAttribute('aria-controls');
    let $target = document.querySelector(`#${controls}`);
    let isExpanded = $trigger.getAttribute('aria-expanded');
    let isHidden = true;
    if (isExpanded === 'false') {
      isExpanded = true;
      isHidden = false;
    } else {
      isExpanded = false;
      isHidden = true;
    };
    this.$modalTriggers.forEach($trigger => {
      $trigger.setAttribute('aria-expanded', isExpanded);
    });
    $target.setAttribute('aria-hidden', isHidden);
  };
  _submit = () => {
    const id = this.$modalFormId.value;
    const password = this.$modalFormPassword.value;
    if (id === this.login.id && password === this.login.password) {
      this._modal(this.$modalClose);
      this._articleDisplay();
      this._setCookie();
    } else {
      alert('IDとPASSWORDが異なります。');
    };
  };
  _articleDisplay = () => {
    this.$t.style.display = 'none';
    this.$continue.style.display = 'block';
  };
  _setCookie = () => {
    let date = new Date();
    date.setTime(date.getTime() + (this.cookieSettings.expires * 24 * 60 * 60 * 1000));
    let expires = date.toUTCString();
    document.cookie = `${this.cookieSettings.name} = 1; expires = ${expires}; path = ${this.cookieSettings.path};`;
  };
};
const $articleMember = document.querySelector('.article-member');
if ($articleMember) new articleMember($articleMember);